import { render } from "./EsMuseo.vue?vue&type=template&id=56c8e8de"
import script from "./EsMuseo.vue?vue&type=script&lang=js"
export * from "./EsMuseo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__